import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { ThirdPartyLoginWrapper } from './ThirdPartyLoginElements.styles';
import GoogleLoginButton from '../google/GoogleLoginButton';
import { MicrosoftLoginButton } from '../microsoft/MicrosoftLoginButton';
import { useMicrosoftLogin } from '../../hooks/useMicrosoftLogin';
export const ThirdPartyLoginElements = ({
  onGoogleLoginClick,
  triggerReset
}) => {
  const {
    loginWithMicrosoft
  } = useMicrosoftLogin({
    handleError: triggerReset
  });
  return /*#__PURE__*/_jsxs(ThirdPartyLoginWrapper, {
    children: [/*#__PURE__*/_jsx(GoogleLoginButton, {
      onClick: onGoogleLoginClick
    }), /*#__PURE__*/_jsx(MicrosoftLoginButton, {
      onClick: loginWithMicrosoft
    })]
  });
};